<template lang="html">
  <div class="blog-outfit-container">
    <OutfitContent :outfit="outfit" v-on:click.native="openOutfit()" />
  </div>
</template>

<script>
import OutfitContent from "@/components/stitchedOutfits/OutfitContent";

export default {
  components: {
    OutfitContent,
  },

  props: {
    outfit: {
      type: Object,
      required: true,
    },
  },

  methods: {
    openOutfit() {
      this.$router.push({
        name: "ShowCapsule",
        params: { capsuleId: this.outfit.capsule_id },
        query: { outfitId: this.outfit.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.blog-outfit-container /deep/ {
  padding: 10px 20px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 30px;
  background: $grey8;
  border: 1px solid $grey5;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  .carousel-item {
    padding: 10px !important;

    .carousel-caption {
      bottom: -10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blogEntry/BlogOutfit.vue